import React from "react";
import { Space, Button } from "antd";
import FeedSection from "./FeedSection";
import { useIntl } from "react-intl";
import EditActivityModal from "../activity/EditActivityModal";
import FeedWrapper from "./index.style";
import useFeed from "../../hooks/useFeed";

const LoadMoreButton = ({ isLoading, onClick, message }) => (
  <div
    style={{
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Button onClick={onClick} type="dashed" loading={isLoading}>
      {message}
    </Button>
  </div>
);

const Feed = (props) => {
  const {
    entity,
    entityId,
    branchId,
    feedReloadTimestamp,
    onReloadFeed,
    setItems,
  } = props;
  const intl = useIntl();
  const {
    upcoming,
    pastactivities,
    activeRecord,
    setActiveRecord,
    editVisible,
    setEditVisible,
    loadMore,
    isLoading,
    total,
    limit,
  } = useFeed(entity, entityId, branchId, feedReloadTimestamp, setItems);

  const onEditActivity = (r) => {
    setActiveRecord(r);
    setEditVisible(true);
  };

  const hide = () => {
    setEditVisible(false);
    setActiveRecord(null);
  };

  const activeEventType = activeRecord?.event
    ? "event"
    : activeRecord?.task?.type;
  return (
    <FeedWrapper>
      <div className="component">
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: "flex",
          }}
        >
          <FeedSection
            activities={upcoming}
            title={intl.formatMessage({
              id: `app.activities.upcoming_activities`,
            })}
            activeKey={"upcoming_activities"}
            entity={entity}
            entityId={entityId}
            branchId={branchId}
            reload={onReloadFeed}
            onEditActivity={onEditActivity}
          />
          <FeedSection
            activities={pastactivities}
            title={intl.formatMessage({
              id: `app.activities.past_activities`,
            })}
            activeKey={"past_activities"}
            entity={entity}
            entityId={entityId}
            branchId={branchId}
            reload={onReloadFeed}
            onEditActivity={onEditActivity}
          />
          {total > limit && (
            <LoadMoreButton
              isLoading={isLoading}
              onClick={loadMore}
              message={intl.formatMessage({
                id: `app.actions.load_more_activities`,
              })}
            />
          )}
        </Space>
      </div>
      <EditActivityModal
        hide={hide}
        record={activeRecord?.event || activeRecord?.task}
        recordId={activeRecord?.event_id || activeRecord?.task_id}
        visible={editVisible}
        type={activeEventType}
        entity={entity}
        entityId={entityId}
        branchId={branchId}
        onReloadFeed={onReloadFeed}
      />
    </FeedWrapper>
  );
};

export default Feed;
